import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, SettingsIcon } from 'lucide-react';
import { AvisAtna } from '../components/avis/AvisAtna';
import { ImportantForYou } from '../components/avis/ImportantForYou';
import { NoticeFeed, type NoticeFilter } from '../components/avis/NoticeFeed';
import { NoticeSignup } from '../components/avis/NoticeSignup';
import { useAuth } from '../contexts/AuthContext';
export function AvisNotifications() {
  const [filter, setFilter] = useState<NoticeFilter>('Tous');
  const {
    isAuthenticated
  } = useAuth();
  const location = useLocation();
  const guestAccess = (location.state as {
    sansCompte?: boolean;
  } | null)?.sansCompte === true;
  const handleChip = (chip: string) => {
    if (chip === 'Mes alertes importantes') setFilter('Importants');
    if (chip === 'Non lus') setFilter('Non lus');
    if (chip === 'Cette semaine') setFilter('Tous');
  };

  // Sans session, le module propose l'inscription — sauf si le visiteur a choisi « Continuer sans compte ».
  if (!isAuthenticated && !guestAccess) return <NoticeSignup data-id="element-2950" data-mp="1j861soedujep" />;
  return <main className="bg-white" data-id="element-2951" data-mp="1j8xn96e9n0r9">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2952" data-mp="1j9phodw4msfy">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2953" data-mp="1xxkb5whyl0u3">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2954" data-mp="1t5ahc5dq3gmj">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2955" data-mp="26zjtqt8mgcz5" />
          <span aria-current="page" data-id="element-2956" data-mp="22v3q6ymhdhn3">Notifications</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-2957" data-mp="2gw6d1dlauvz2">
          <div data-id="element-2958" data-mp="2bwtg200ps8ir">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2959" data-mp="2bw1snch9th3k">
              Notifications
            </h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-2960" data-mp="mhvoz7cj45uc">Restez informé de ce qui vous concerne.</p>
          </div>
          <Link to="/notifications/parametres" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2961" data-mp="hkn1qscixbm8">
            <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-2962" data-mp="2vluqe0tcj7b2" />
            Paramètres
          </Link>
        </header>

        <div className="mt-8" data-id="element-2963" data-mp="30htjg1pmddht">
          <AvisAtna onFilter={handleChip} data-id="element-2964" data-mp="35i7fsmhuyz00" />
        </div>

        <ImportantForYou data-id="element-2965" data-mp="35gmmt1b6zo49" />
        <NoticeFeed filter={filter} onFilterChange={setFilter} data-id="element-2966" data-mp="3a9plfnuttnrb" />
      </div>
    </main>;
}